import React from "react";
import { SectionHeading } from "./SectionHeading";
import { Star } from "lucide-react";
import { cn } from "@/lib/utils";
import { Reveal, RevealStagger, RevealItem } from "./Reveal";

const testimonials = [
  {
    quote:
      "The booking page looks like it was custom-built for my brand. Clients constantly tell me how easy it is to book — that’s the best marketing there is.",
    name: "Jordan Lee",
    role: "Barber",
    initials: "JL",
    avatar: "bg-cyan text-white",
  },
  {
    quote:
      "As a solo makeup artist, deposits changed everything. I’m no longer losing income to last-minute cancellations on bridal bookings.",
    name: "Priya Nair",
    role: "Makeup Artist",
    initials: "PN",
    avatar: "bg-pink text-white",
  },
];

export default function Testimonials() {
  return (
    <section className="px-4 py-12 sm:py-16">
      <div className="mx-auto max-w-6xl">
        <Reveal>
          <SectionHeading
            eyebrow="Loved by Barbers & Make-up artists"
            title="Trusted by Australia’s best"
            description="Join the growing number of beauty professionals exploring SlotBook."
          />
        </Reveal>

        <RevealStagger className="mt-12 grid gap-4 sm:grid-cols-2">
          {testimonials.map((t) => (
            <RevealItem key={t.name}>
              <figure className="flex h-full flex-col justify-between rounded-2xl border border-border bg-card p-7 transition-shadow hover:soft-shadow">
                <div className="flex gap-0.5 text-amber">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <Star key={i} className="size-4 fill-current" />
                  ))}
                </div>
                <blockquote className="mt-5 text-pretty text-lg leading-relaxed text-foreground">
                  {`“${t.quote}”`}
                </blockquote>
                <figcaption className="mt-7 flex items-center gap-3">
                  <span
                    className={cn(
                      "flex size-11 items-center justify-center rounded-full text-sm font-semibold",
                      t.avatar,
                    )}
                  >
                    {t.initials}
                  </span>
                  <div>
                    <p className="text-sm font-medium text-foreground">
                      {t.name}
                    </p>
                    <p className="text-sm text-muted-foreground">{t.role}</p>
                  </div>
                </figcaption>
              </figure>
            </RevealItem>
          ))}
        </RevealStagger>
      </div>
    </section>
  );
}
